const handleChangeDefault = (evt, data, setData) => {
  evt.preventDefault();
  if (evt.target.getAttribute('number') === 'on') {
    if (evt.target.value.match(/^\d+$/) || evt.target.value === '') {
      setData({
        ...data,
        [evt.target.name]: evt.target.value
      });
    } else {
      evt.target.value = data[evt.target.name];
    }
  } else {
    const isCheckbox = evt.target.type === 'checkbox';
    setData({
      ...data,
      [evt.target.name]: isCheckbox ? evt.target.checked : evt.target.value
    });
  }
};

export default handleChangeDefault;
